export default __webpack_public_path__ + "static/media/argentanmini.179c0b64.jpg";